import React from "react";
export default function FivePage(){
    return <>
        <p className="faFont">خطایی رخ داده است</p>
    </>
}